import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import SubscribeFormFull from 'components/Forms/SubscribeFormFull';
import WpImage from 'components/WPImage';
import Icon from 'components/UI/Icon';
import { TEMPLATES_PAGE } from 'constants/urls';

import * as styles from './lead.module.scss';

const Lead = ({ data }) => {
  const {
    templateLeadGeneratorHero: {
      templateLeadGeneratorHeroBanner,
      templateLeadGeneratorHeroBackButton,
      templateLeadGeneratorHeroTitle,
      templateLeadGeneratorHeroDescription,
    },
  } = data;

  return (
    <div className={classnames('scr-template-hero-inner')}>
      <div
        className={classnames(styles.media, 'scr-template-hero-inner__media')}
      >
        <WpImage
          src={templateLeadGeneratorHeroBanner?.sourceUrl || '#'}
          alt={templateLeadGeneratorHeroBanner?.altText}
        />
      </div>

      <div className={classnames('scr-template-hero-inner__content')}>
        <Link
          className={classnames('scr-template-conten-btn-back scr-link')}
          to={TEMPLATES_PAGE}
        >
          <Icon name="chevron-left" /> {templateLeadGeneratorHeroBackButton}
        </Link>

        <h3 className={classnames('scr-template-conten-title scr-h3')}>
          {templateLeadGeneratorHeroTitle}
        </h3>

        <p className={classnames(styles.description)}>
          {templateLeadGeneratorHeroDescription}
        </p>

        <div>
          <SubscribeFormFull />
        </div>
      </div>
    </div>
  );
};

export default Lead;
